import Navbar from "../components/other/navbar";
import {Chart} from "../components/chart/Chart";

function ChartPage() {

    if(!sessionStorage.getItem('token')){
        window.location.href = '/login';
    }

    return (
        <div className="Planning">
            <Navbar page={'Chart'}/>
            <div className="centered-element">
                <Chart/>
            </div>
        </div>
    );
}

export default ChartPage;